import React, { Component } from 'react'
import values from 'mout/object/values'
import { Col, Label, Input, Dropdown, DropdownMenu, DropdownToggle, } from 'reactstrap'
import sortByPropText from '../../../../../helpers/content/manageSets/sortByPropText';

class NavSelector extends Component {
  state = {
    filterText: '',
    isOpen: false,
  }

  toggle = () => this.setState({isOpen: !this.state.isOpen})

  changeFilter = ({target}) => this.setState({filterText: target.value})

  filterRule = r => {
    const { filterText } = this.state
    return (
      !filterText ||
      r.name && r.name.toLowerCase().indexOf(filterText.toLowerCase()) > -1 ||
      r.fullName && r.fullName.toLowerCase().indexOf(filterText.toLowerCase()) > -1
    )
  }

  handleClick = (id) => {
    const { history, baseLink } = this.props
    history.push(`${baseLink}${id}`)
    this.setState({isOpen: false, filterText: '',})
  }

  render() {
    const { records, id, name, history, baseLink, parentRecord } = this.props
    const { isOpen, filterText, } = this.state
    const { toggle, changeFilter, filterRule, handleClick } = this
    
    const displayNames = {
      districts: 'District',
      schools: 'School',
      teachers: 'Teacher',
      classes: 'Class',
    }
    let sortedRecords

    // filters so only showing records belonging to parent
    if (name === 'teachers') {
      const teachs = values(records)
                      .filter(ed => ed.role === 'Teacher' || ed.isTeacher)
                      .filter(t => t.school === parentRecord.id)
                      .filter(filterRule)
      sortedRecords = sortByPropText(teachs, 'lastName')
    } else {
      let filteredRecords = values(records)
      if (name === 'schools') {
        filteredRecords = filteredRecords.filter(r => r.district === parentRecord.id).filter(filterRule)
      }
      sortedRecords = sortByPropText(values(filteredRecords), 'name')
    }

    return (
      <Col xs='3' className='dropdown selector'>
        <Dropdown isOpen={isOpen} toggle={toggle}>
          <DropdownToggle
            tag='span'
            onClick={toggle}
            data-toggle='dropdown'
            aria-expanded={isOpen}
          >
            <span className='title'>{displayNames[name]}: </span>
            <Input
              type='text'
              value={isOpen ? filterText : records && id && (records[id].name || records[id].fullName)}
              onChange={changeFilter}
            />
          </DropdownToggle>
          <DropdownMenu>
            {sortedRecords.map(record =>
              <div
                key={`ns${record.id}`}
                onClick={() => handleClick(record.id)}
                className='m2clickable'
              >
                {record.fullName || record.name}
              </div>
            )}
          </DropdownMenu>
        </Dropdown>
      </Col>
    )

    // return (
    //   <Col xs='3' className='nav selector'>
    //     <span className='title'>{displayNames[name]}: </span>
    //     <Input
    //       type='select'
    //       onChange={({ target }) => history.push(`${baseLink}${target.value}`)}
    //       value={id}
    //     >
    //       {sortedRecords.map((record) =>
    //         <option
    //           key={`ns${record.id}`}
    //           value={record.id}
    //         >
    //           {name === 'teachers' ? record.fullName : record.name}
    //         </option>
    //       )

    //       }
    //     </Input>
    //   </Col>
    // )
  }
}

export default NavSelector


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/SelectorComponents/NavSelector.js